import React, { useState } from 'react';
import { useUsersData } from '../../../../../../../Hooks/TT_ELD/Users';
import { useParams } from 'react-router-dom';
import { Button, TableProps, Tabs } from 'antd';
import SearchInput from '../../../../../../../Utils/SearchInput';
import UsersTable from '../../../Users/UsersTable';
import useRouteQuery from '../../../../../../../Utils/useRouterQuery';
import { TableParams } from '../../../../../../../Utils/TableTypes';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { isWhiteLabelAdmin } from '../../../../../../../Utils/whiteLabel';

const TabDrivers = () => {
  const { id } = useParams();
  const [userName, setUserName] = useState<undefined | string>('');
  const [status, setStatus] = useState<boolean>(true);
  const [driverId, setDriverId] = useRouteQuery('', 'driverId', (v) => String(v));
  const [driverEmail, setDriverEmail] = useRouteQuery('', 'driverEmail', (v) => String(v));
  const [publicId, setPublicId] = useRouteQuery('', 'publicId', (v) => String(v));
  const [uid, setUid] = useRouteQuery('', 'uid', (v) => String(v));
  const [companyUID, setCompanyUID] = useRouteQuery('', 'companyUID', (v) => String(v));
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const companyId = id;

  const isWhiteLabel = isWhiteLabelAdmin();

  const { data, refetch, isLoading, isFetching } = useUsersData(
    companyId,
    'driver',
    status,
    driverId,
    driverEmail,
    userName,
    '',
    uid,
    companyUID,
    tableParams,
    publicId,
  );

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      driverId: setDriverId,
      driverEmail: setDriverEmail,
      uid: setUid,
      companyUID: setCompanyUID,
      publicId: setPublicId,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
    }

    setTableParams((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        current: 1,
      },
    }));
  };

  const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter) => {
    if (!Array.isArray(sorter)) {
      const mapOrderToString = (order: 'ascend' | 'descend' | null | undefined): string | null => {
        if (order === 'ascend') return 'true';
        if (order === 'descend') return 'false';
        return null;
      };
    }

    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  return (
    <div className="mainPage">
      <Tabs
        activeKey={status ? 'active' : 'inactive'}
        onChange={(key) => {
          if (key === 'active') setStatus(true);
          else if (key === 'inactive') setStatus(false);

          setTableParams({
            pagination: {
              current: 1,
              pageSize: tableParams.pagination?.pageSize || 10,
            },
          });
        }}
        items={[
          {
            label: (
              <span>
                <CheckCircleOutlined style={{ marginRight: 8 }} />
                Active
              </span>
            ),
            key: 'active',
          },
          {
            label: (
              <span>
                <CloseCircleOutlined style={{ marginRight: 8 }} />
                Inactive
              </span>
            ),
            key: 'inactive',
          },
        ]}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <SearchInput
            value={driverId}
            placeholder="Driver name"
            onDebounceChange={(event: string) => handleChange(event, 'driverId')}
          />
          <SearchInput
            value={driverEmail}
            placeholder="Driver email"
            onDebounceChange={(event: string) => handleChange(event, 'driverEmail')}
          />
          <SearchInput
            value={publicId}
            placeholder="Search by Public ID"
            onDebounceChange={(event: string) => handleChange(event, 'publicId')}
            enterButtonSize="8"
            searchWidth={'240px'}
          />
          {!isWhiteLabel && (
            <>
              <SearchInput
                value={uid}
                placeholder="Search by UID"
                onDebounceChange={(event: string) => handleChange(event, 'uid')}
              />
              <SearchInput
                value={companyUID}
                placeholder="Search by Company UID"
                onDebounceChange={(event: string) => handleChange(event, 'companyUID')}
              />
            </>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
          <Button
            style={{ float: 'right', marginLeft: '15px' }}
            size={'large'}
            onClick={() => refetch()}
          >
            Refresh
          </Button>
        </div>
      </div>
      <UsersTable
        data={data?.data}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
        handleTableChange={handleTableChange}
        tableParams={tableParams}
        pagination={{ total: data?.count, showSizeChanger: false }}
      />
    </div>
  );
};

export default TabDrivers;
